module.exports = __webpack_public_path__ + "assets/Chat_grey.551494189b1335601c0090e94c597052.svg";